import { useCompanyStore } from "../states/store/Company";
import { ICompany } from "../../types/company.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

export const getCompanyId = () => {
  const { filterMode, selectedCompanies } = useCompanyStore.getState();

  if (filterMode === "cities" && selectedCompanies.length > 0) {
    return selectedCompanies.map((c) => c.companyId).join(",");
  }

  if (filterMode === "uf" || filterMode === "region") {
    return null;
  }
  const company = localStorage.getItem("selectedCompanies");
  if (company) {
    const parsedCompany = JSON.parse(company);
    return parsedCompany.companyId;
  }
  return null;
};

export const getSelectedUF = () => {
  const { filterMode, selectedUf } = useCompanyStore.getState();

  if (filterMode === "uf" && selectedUf) {
    return selectedUf;
  }

  return null;
};

export const getSelectedRegion = () => {
  const { filterMode, selectedRegion } = useCompanyStore.getState();

  if (filterMode === "region" && selectedRegion) {
    return selectedRegion;
  }

  return null;
};
export const getActiveCompaniesList = async () => {
  const url = `${API_URL}/list/actives`;

  const result = (await makeRequestDebounced(url)) as Promise<
    ApiResponseType<
      Array<{ id: string; name: string; sigla: string; active: boolean }>
    >
  >;
  return result;
};
export const getCompanies = () => {
  const companies = localStorage.getItem("companyAccess");
  if (companies) {
    return JSON.parse(companies);
  } else {
    return [];
  }
};

const API_URL = `${import.meta.env.VITE_API_URL}/companies`;
const makeRequestDebounced = createDebounce(makeRequest, 200);

export const getAllCompanies = async () => {
  const params = new URLSearchParams({
    itemsPerPage: "100",
  });
  const url = `${API_URL}/?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as Promise<
    ApiResponseType<ICompany[]>
  >;
  return result;
};

export const getPaginationCompanies = async ({
  search = "",
  page = 1,
  itemsPerPage = 10,
  orderBy = "socialname",
  fields = "_id,socialname,fantasyname,cnpj,email,phone,address,observations,taxBurdens,accessTokens,leadGoals,contacts,active",
} = {}) => {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });

  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);

  const url = `${API_URL}/?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as Promise<
    ApiResponseType<ICompany[]>
  >;
  return result;
};

export const createCompany = async (company: ICompany) => {
  const url = `${API_URL}/`;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { _id, ...companyWithoutId } = company;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(companyWithoutId),
  };
  const result = (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<ICompany>
  >;
  return result;
};

export const updateCompany = async (company: ICompany) => {
  const url = `${API_URL}/${company._id}`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(company),
  };
  const result = (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<ICompany>
  >;
  return result;
};
